import { i18n } from '@/plugins/i18n'

function changeTitle(to, from, next) {
  window.document.title = `${i18n.t(to.name.replaceAll('-', ' '))} | APSTH Platform Clinic 3.9`

  return next()
}
export default changeTitle
